import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../API/axiosNeatex';
import type { APIResponse } from '@store/Shared/shared';

// import { getData, postData } from "../../Axios/axiosData";

export const GetElementLinkDeatail = createAsyncThunk(
  'ElementLink/GetElementLinkDeatail',
  async (id: string, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;

    try {
      // const data = await getData(`Payroll/GetElementLinkDetail?PayrollId=${id}`);
      const { data } = await ntxAPI.get(`Payroll/GetElementLinkDetail?PayrollId=${id}`);
      return data;
    } catch (error: any) {
      console.error(error);
      return rejectWithValue(error.message);
    }
  }
);

export const AddElementLink = createAsyncThunk(
  'ElementLink/AddElementLink',
  async (item: any, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;

    try {
      // const data = await postData( "Payroll/AddElementLink", item);
      const { data } = await ntxAPI.post('Payroll/AddElementLink', item);
      return data;
    } catch (error: any) {
      console.error(error);
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateElementLink = createAsyncThunk(
  'ElementLink/UpdateElementLink',
  async (item: any, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;

    try {
      const { data } = await ntxAPI.post('Payroll/UpdateElementLink', item);
      return data;
    } catch (error: any) {
      console.error(error);
      return rejectWithValue(error.message);
    }
  }
);

export const changeActiveElementLink = createAsyncThunk(
  'ElementLink/GetElementLinkDeatail',
  async (id: any, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;

    try {
      const { data } = await ntxAPI.post(`Payroll/ChangeActiveElementLink?Id=${id}`);
      return data;
    } catch (error: any) {
      console.error(error);
      return rejectWithValue(error.message);
    }
  }
);

export const checkFormula = createAsyncThunk(
  'ElementLink/checkFormula',
  async (item: any, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;

    try {
      const { data } = await ntxAPI.post<APIResponse<number>>('Payroll/CheckFormula', item);
      return data;
    } catch (error: any) {
      console.error(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getStaticElement = createAsyncThunk(
  'ElementLink/getStaticElement',
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const { data } = await ntxAPI.post('Payroll/GetStaticElement');
      return data;
    } catch (error: any) {
      console.error(error);
      return rejectWithValue(error.message);
    }
  }
);

const initialState: {
  ElementLinkDeatail: any;
  loading: boolean;
  error: any | null;
  //~~
  StaticElement: any[];
  loading2: boolean;
  error2: any | null;
} = {
  ElementLinkDeatail: null,
  loading: false,
  error: null,
  //~~~~~~~
  StaticElement: [],
  loading2: false,
  error2: null
};

const ElementLinkSlice = createSlice({
  name: 'ElementLink',
  initialState,
  reducers: {
    cleanUpElementLinkDeatail: state => {
      state.ElementLinkDeatail = null;
      // state.ElementLinkDeatail = {};
    }
  },
  extraReducers(builder) {
    builder

      /////// get ElementLinkDetail
      .addCase(GetElementLinkDeatail.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetElementLinkDeatail.fulfilled, (state, action) => {
        state.loading = false;
        state.ElementLinkDeatail = action.payload;
      })
      .addCase(GetElementLinkDeatail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      ////// AddElementLink
      .addCase(AddElementLink.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AddElementLink.fulfilled, (state, action) => {
        state.loading = false;
        state.ElementLinkDeatail = action.payload;
      })
      .addCase(AddElementLink.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //~~~~~~~~~~~~~~~~~~~~~
      .addCase(getStaticElement.pending, state => {
        state.loading2 = true;
        state.error2 = null;
      })
      .addCase(getStaticElement.fulfilled, (state, action) => {
        state.loading2 = false;
        state.StaticElement = action.payload;
      })
      .addCase(getStaticElement.rejected, (state, action) => {
        state.loading2 = false;
        state.error2 = action.payload;
      });
  }
});

export const { cleanUpElementLinkDeatail } = ElementLinkSlice.actions;
export default ElementLinkSlice.reducer;
